import { render } from "./RenewalNoticePopup.vue?vue&type=template&id=fabf1a84&scoped=true&ts=true"
import script from "./RenewalNoticePopup.vue?vue&type=script&lang=ts"
export * from "./RenewalNoticePopup.vue?vue&type=script&lang=ts"

import "./RenewalNoticePopup.vue?vue&type=style&index=0&id=fabf1a84&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabf1a84"]])

export default __exports__